import { render, staticRenderFns } from "./PointsLedger.vue?vue&type=template&id=9d05becc&scoped=true"
import script from "./PointsLedger.vue?vue&type=script&lang=js"
export * from "./PointsLedger.vue?vue&type=script&lang=js"
import style0 from "./PointsLedger.vue?vue&type=style&index=0&id=9d05becc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d05becc",
  null
  
)

export default component.exports